import * as Storage from "../storage";

export const loadAnswers = (dbAnswers) => {
  const localAnswers = Storage.getItem(["survey", "answers"]) ?? {};
  if (dbAnswers && Object.keys(dbAnswers).length > Object.keys(localAnswers).length) {
    return dbAnswers;
  } else {
    return localAnswers;
  }
};

// TODO: Transformar a funciones puras. ahora mismo lo que hace es mutar el objeto que se pasa por parámetro (answers)
export const updateAnswersOnMarkedAnswer = (
  answers,
  dimensionIndex,
  questionIndex,
  question,
  formData
) => {
  const { id, name, value, type } = formData;

  answers[dimensionIndex] = answers[dimensionIndex] || {};
  answers[dimensionIndex][questionIndex] = answers[dimensionIndex][questionIndex] || {};

  const { question_type } = question;

  answers[dimensionIndex][questionIndex]["question_type"] = question_type;

  answers[dimensionIndex][questionIndex]["items"] =
    answers[dimensionIndex][questionIndex]["items"] || {};

  const items = answers[dimensionIndex][questionIndex]["items"];

  switch (question_type) {
    case "input":
      const { numberOfFields = 1 } = question;
      if (numberOfFields === 1) {
        items["answer"] = value;
      } else {
        items["answer"] = items["answer"] ?? Array(numberOfFields).fill("");
        items["answer"][parseInt(name)] = value;
      }
      break;
    case "textarea":
    case "range":
      items["answer"] = value;
      break;
    case "dropdown":
      const { selection, options } = question;
      switch (selection) {
        case "multiple": {
          const selectedOptionIndex = parseInt(
            id.replace(`dropdown_${dimensionIndex}_${questionIndex}_`, "")
          );
          var answerObj = items["answer"];
          if (!answerObj) {
            answerObj = options.map((option) => ({ name: option, value: false }));
          } else {
            answerObj = items["answer"];
          }
          answerObj[selectedOptionIndex]["value"] = true;
          items["answer"] = answerObj;

          break;
        }
        case "single":
        default: {
          items["answer"] = value;
          break;
        }
      }
      break;
    case "options":
      items["additionalAnswers"] = items["additionalAnswers"] || {};
      switch (type) {
        case "checkbox": {
          const { options, additionalInputs, other } = question;
          const selectedOptionIndex = parseInt(
            id.replace(`options_${dimensionIndex}_${questionIndex}_`, "")
          );
          var answerObj = items["answer"];

          if (!answerObj) {
            answerObj = options.map((option) => ({ name: option, value: false }));
            if (other) {
              answerObj.push({ name: "Otro", value: false });
            }
          } else {
            answerObj = items["answer"];
          }

          answerObj[selectedOptionIndex]["value"] = true;
          items["answer"] = answerObj;

          if (additionalInputs) {
            const textVisibleOptions = question["additionalInputs"].map(
              (additionalInput) => additionalInput["relatedOption"]
            );
            if (textVisibleOptions.includes(value)) {
              items["additionalAnswers"][value] = "";
            }
            if (question["other"] && value === "Otra") {
              items["additionalAnswers"]["Otra"] = "";
            }
          }
          break;
        }
        case "text": {
          items["additionalAnswers"][name] = value;
          break;
        }
        case "radio":
        default: {
          items["answer"] = value;
          if (value === "Otro") {
            items["additionalAnswers"] = { Otro: "" };
          } else {
            items["additionalAnswers"] = {};
          }
          break;
        }
      }
      break;
    case "matrix":
      const [rowIndex, columnIndex] = name
        .replace(`survey-question-field-matrix_${dimensionIndex}_${questionIndex}-cell-`, "")
        .split("_");
      const { rows, columns = [], orientation, matrixType } = question;
      const numberOfColumns = columns.length > 0 ? columns.length : 1;
      var answerObj = items["answer"];

      switch (matrixType) {
        case "selects":
          if (!answerObj) {
            answerObj = [];
            for (var i = 0; i < rows.length; i++) {
              let item;
              if (columns && columns.length > 0) {
                for (var j = 0; j < columns.length; j++) {
                  item = { row: rows[i], column: columns[j], value: "" };
                  answerObj.push(item);
                }
              } else {
                item = { row: rows[i], value: "" };
                answerObj.push(item);
              }
            }
          }
          answerObj[parseInt(columnIndex) + parseInt(rowIndex) * numberOfColumns]["value"] = value;

          break;
        case "radios":
        default:
          if (!answerObj) {
            answerObj =
              orientation === "column"
                ? columns.map((column) => ({ name: column, value: null }))
                : rows.map((row) => ({ name: row, value: null }));
          }

          if (orientation === "column") {
            answerObj[parseInt(columnIndex)]["value"] = rows[parseInt(rowIndex)];
          } else {
            answerObj[parseInt(rowIndex)]["value"] = value;
          }
          break;
      }
      items["answer"] = answerObj;
      break;
    default:
      break;
  }

  return answers;
  // return {...answers, dimensionIndex: {...answers[dimensionIndex], questionIndex: {...answers[dimensionIndex][questionIndex], items}}};
};

export const updateAnswersOnDeletedAnswer = (
  answers,
  dimensionIndex,
  questionIndex,
  question,
  formData
) => {
  const { question_type } = question;
  const { id, name, value } = formData;
  switch (question_type) {
    case "input":
      const { numberOfFields = 1 } = question;
      if (numberOfFields === 1) {
        delete answers[dimensionIndex][questionIndex];
      } else {
        var answer = answers[dimensionIndex][questionIndex]["items"]["answer"];
        answer[parseInt(name)] = value;
        const allAnswersEmpty = answer.every((element) => element === "");

        if (allAnswersEmpty) {
          delete answers[dimensionIndex][questionIndex];
        }
      }
      break;
    case "dropdown":
      const { selection = "single" } = question;
      switch (selection) {
        case "multiple":
          const answersObj = answers[dimensionIndex][questionIndex]["items"]["answer"];
          const deselectedOptionIndex = parseInt(
            id.replace(`dropdown_${dimensionIndex}_${questionIndex}_`, "")
          );

          answersObj[deselectedOptionIndex]["value"] = false;

          answers[dimensionIndex][questionIndex]["items"]["answer"] = answersObj;

          const noOptionsSelected = answersObj.every((answer) => answer["value"] === false);

          if (noOptionsSelected) {
            delete answers[dimensionIndex][questionIndex];
          }
          break;
        case "single":
        default:
          delete answers[dimensionIndex][questionIndex];
          break;
      }
      break;
    case "options":
      const { type } = formData;
      if (type === "checkbox") {
        // Listado de respuestas con true o false, la deseleccionada se le asigna false
        const answersObj = answers[dimensionIndex][questionIndex]["items"]["answer"];
        const deselectedOptionIndex = parseInt(
          id.replace(`options_${dimensionIndex}_${questionIndex}_`, "")
        );

        answersObj[deselectedOptionIndex]["value"] = false;

        if (value === "Otro") {
          delete answers[dimensionIndex][questionIndex]["items"]["additionalAnswers"][value];
        }

        answers[dimensionIndex][questionIndex]["items"]["answer"] = answersObj;

        const noOptionsSelected = answersObj.every((answer) => answer["value"] === false);

        if (noOptionsSelected) {
          delete answers[dimensionIndex][questionIndex];
        }
      } else if (type === "text") {
        answers[dimensionIndex][questionIndex]["items"]["additionalAnswers"][name] = "";
      }

      break;
    case "matrix":
      const { matrixType, columns = [] } = question;
      const [rowIndex, columnIndex] = name
        .replace(`survey-question-field-matrix_${dimensionIndex}_${questionIndex}-cell-`, "")
        .split("_");

      const numberOfColumns = columns.length > 0 ? columns.length : 1;

      switch (matrixType) {
        case "selects":
          answers[dimensionIndex][questionIndex]["items"]["answer"][
            parseInt(columnIndex) + parseInt(rowIndex) * numberOfColumns
          ]["value"] = "";
          const allAnswerItemsEmpty = answers[dimensionIndex][questionIndex]["items"][
            "answer"
          ].every((item) => item["value"] === "");
          if (allAnswerItemsEmpty) {
            delete answers[dimensionIndex][questionIndex];
          }
          break;
        case "radios":
        default:
          // Dado que no se puede deseleccionar o borrar una opción, no es necesario borrar la respuesta
          break;
      }
      break;
    default:
      delete answers[dimensionIndex][questionIndex];
      break;
  }
  if (Object.keys(answers[dimensionIndex]).length === 0) {
    delete answers[dimensionIndex];
  }
  return answers;
};

export const updateAnswersOnHiddenQuestion = (answers, dimensionIndex, questionIndex) => {
  delete answers[dimensionIndex][questionIndex];

  if (Object.keys(answers[dimensionIndex]).length === 0) {
    delete answers[dimensionIndex];
  }

  return answers;
};

export const clearAnswersFromDimension = (answers, dimensionIndex) => {
  if (!answers) {
    return answers;
  }

  if (!answers[dimensionIndex]) {
    return answers;
  }

  delete answers[dimensionIndex];

  return answers;
};

export const getAnswer = (answers, dimensionIndex, questionIndex, questionType = "") => {
  const items = answers?.[dimensionIndex]?.[questionIndex]?.["items"] || null;

  switch (questionType) {
    case "options":
      return items;
    default:
      return items?.answer || null;
  }
};
